import {Avatar, DatePicker, Input, Modal, Radio} from 'antd'
import {
    course_class_exam_evaluateExamAttempt_Api,
    course_class_exam_fetchAttemptsFiltered_Api,
    course_class_exam_removeExamAttempt_Api,
    course_class_getGradeDetails_Api,
    course_class_setGradeScore_Api,
    courseClassExamSchema
} from 'apis'
import {getId} from 'apis/model/base'
import classNames from 'classnames'
import FieldsFactory from 'components/form/FieldsFactory'
import {ResetButton, SubmitButton} from 'components/form/FormActionBar'
import {createValue} from 'components/form/utils'
import Pure from 'components/Pure'
import {Formik, FormikConsumer} from 'formik'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import Translate from 'modules/local/Translate'
import useTranslate from 'modules/local/useTranslate'
import React, {useCallback, useContext, useMemo, useState} from 'react'
import {BiMessageSquareAdd, BiMessageSquareEdit, BiSolidMagicWand, BiTrash,} from 'react-icons/bi'
import {BsInfoCircleFill, BsPersonFill} from 'react-icons/bs'
import {IoCalendarOutline} from 'react-icons/io5'
import {mapProps} from 'recompose'
import {SelectWidget} from 'views/AppLocals/custom/ReactSelectComponents'
import EntityList from 'views/AppLocals/EntityList'
import {notifyOnError} from 'views/AppLocals/factory/createErrorEvent'
import {createControlledFormField} from 'views/AppLocals/factory/createFormField'
import {bindQueryParam} from 'views/AppLocals/functions/routerHelper'
import {deepTranslate, NullAsDefault, renderIf, shallowDiff} from 'views/Shared'
import {grade_score_types} from '..'
import {formatDate, getDateString, parseDayjs} from '../../../../helpers/datetimeHelpers'
import {gConfigs} from '../../configs'
import {appClassNames} from '../../custom/appClassNames'
import {showDeleteConfirmDialog} from '../../factory/createConfirmDialog'
import {HeaderWithIconLine, ListHeaderLineAndDes, ListHeaderWithLine} from '../../Templates/items/ListHeader'
import {SubjectSelector} from '../components/SubjectSelector'
import CourseClassInformation from './CourseClassInformation'
import {course_class_student_getGradeResult_Api} from "../../../../apis";
import {bindQueryParams} from "../../functions/routerHelper";
import {SubClassTags} from "../components/SubClassTags";
import {ObjectSelectField} from "../../../../components/form/fields/ObjectSelectField";
import getAliasName from "../../../../helpers/getAliasName";
import DrawDialog from "../../../../components/drawer/dialog/DrawDialog";
import {CourseClassGradeDetailHistory} from "./CourseClassGradeHistory";
import dayjs from "dayjs";
import {ActionModalWrapper} from "../../../../components/form/ActionModalWrapper";
import CourseClassExamAttemptEvaluateForm from "../Exam/CourseClassExamAttemptEvaluateForm";
import GradeNumberInput from "../../../../components/form/fields/GradeNumberInput";
import GradeLetterInput from "../../../../components/form/fields/GradeLetterInput";
import {PiClockClockwiseLight} from "react-icons/pi";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {GoDotFill} from "react-icons/go";
import {baseFieldTypes} from "../../../../apis/base/baseFieldTypes";
import LookupField from "../../../../components/LookupField";
import {ItemInformation} from "../../../../components/common/ItemInformation";

const formSchema = {
    title: {
        title: 'title',
        children: [
            {
                name: 'title',
                component: createControlledFormField({
                    placeholder: 'ex: dddd, DD/MM/YYYY',
                }),
            },
        ],
    },
    course_subject: {
        title: 'subjects',
        description: 'grade subject description',
        children: [
            {
                name: 'subject',
                component: mapProps(({name, value, form, onChange}) => {
                    const {subject_id, course_class} = form?.values ?? {}
                    const {class_subjects = []} = course_class || {};
                    const subjects = class_subjects.map(e => ({
                        id: e.subject.id,
                        value: e.subject.id,
                        label: e.subject.title,
                        ...e.subject
                    }));
                    return {
                        name,
                        onChange,
                        onOptionChange: (option) => {
                            onChange(createValue(name, option ?? null))
                        },
                        // bordered: false,
                        value: _.find(subjects, {value: subject_id,})?.id,
                        showSearch: true,
                        options: subjects,
                        style: {
                            padding: 0,
                            border: 0,
                        }
                    }
                })(ObjectSelectField),
            },
        ],
    },
    score_type_weight: {
        inline: true,
        className: appClassNames.inline_3,
        itemClassNames: ['col-span-1', 'col-span-1 md:col-span-2'],
        children: [
            {
                label: 'score type',
                name: 'score_type',
                component: ({name, value, form, onChange}) => {
                    const {values, initialValues, setFieldValue = NullAsDefault} = form ?? {}
                    const options = Array.from(values?.score_type_options ?? [])
                    return (
                        <Translate>
                            {(t) => (
                                <Radio.Group
                                    name={name}
                                    value={value}
                                    options={options.map(({value, label}) => ({
                                        value: value,
                                        label: (
                                            <span className="font-medium text-color-100 italic">{t(label)}</span>
                                        ),
                                    }))}
                                    className="custom-radio-button w-full space-x-3"
                                    onChange={(event) => {
                                        onChange(createValue(name, event.target.value))
                                        const has_options = value === grade_score_types.text.value
                                        setFieldValue(
                                            'score_options',
                                            has_options ? initialValues?.score_options : undefined
                                        )
                                    }}
                                />
                            )}
                        </Translate>
                    )
                },
            },
            {
                label: 'score weight',
                name: 'score_weight',
                component: ({name, value, onChange}) => (
                    <Translate>
                        {(t) => (
                            <Input
                                name={name}
                                value={value}
                                type="number"
                                inputMode="numeric"
                                min={1}
                                max={100}
                                onChange={onChange}
                                placeholder={t('score weight')}
                            />
                        )}
                    </Translate>
                ),
            },
        ],
    },
    score_type_weight_date: {
        inline: true,
        className: appClassNames.inline_3,
        itemClassNames: ['col-span-1', 'col-span-1', 'col-span-1'],
        children: [
            {
                label: 'score type',
                name: 'score_type',
                component: ({name, value, form, onChange}) => {
                    const {values, initialValues, setFieldValue = NullAsDefault} = form ?? {}
                    const options = Array.from(values?.score_type_options ?? [])
                    return (
                        <Translate>
                            {(t) => (
                                <Radio.Group
                                    name={name}
                                    value={value}
                                    options={options.map(({value, label}) => ({
                                        value: value,
                                        label: (
                                            <span className="font-medium text-color-100 italic">{t(label)}</span>
                                        ),
                                    }))}
                                    className="custom-radio-button w-full space-x-3"
                                    onChange={(event) => {
                                        onChange(createValue(name, event.target.value))
                                        const has_options = value === grade_score_types.text.value
                                        setFieldValue(
                                            'score_options',
                                            has_options ? initialValues?.score_options : undefined
                                        )
                                    }}
                                />
                            )}
                        </Translate>
                    )
                },
            },
            {
                label: 'score weight',
                name: 'score_weight',
                component: ({name, value, onChange}) => (
                    <Translate>
                        {(t) => (
                            <Input
                                name={name}
                                value={value}
                                type="number"
                                inputMode="numeric"
                                min={1}
                                max={100}
                                onChange={onChange}
                                placeholder={t('score weight')}
                            />
                        )}
                    </Translate>
                ),
            },
            {
                label: 'grade date',
                name: 'grade_date',
                component: ({name, value, onChange}) => (
                    <Translate>
                        {(t) => (
                            <DatePicker
                                key={value}
                                className="w-full"
                                suffixIcon={<IoCalendarOutline className="text-color-500"/>}
                                allowClear={false}
                                format={gConfigs.dateFormat}
                                defaultValue={value}
                                placeholder={t('grade date')}
                                onChange={(value) => {
                                    onChange(createValue(name, value))
                                }}
                            />
                        )}
                    </Translate>
                ),
            },
        ],
    },
    score_options: {
        title: 'grading levels',
        children: [
            {
                name: 'score_options',
                component: ({name, value, onChange}) => (
                    <Translate>
                        {(t) => (
                            <SelectWidget
                                mode="tags"
                                name={name}
                                value={value}
                                className="w-full"
                                placeholder={t('grading levels placeholder')}
                                onChange={(value) => {
                                    onChange(createValue(name, value))
                                }}
                            />
                        )}
                    </Translate>
                ),
            },
        ],
    },
    grade_date: {
        title: 'grade date',
        children: [
            {
                name: 'grade_date',
                component: ({name, value, onChange}) => {
                    return (
                        <Translate>
                            {(t) => (
                                <DatePicker
                                    key={value}
                                    className="w-full"
                                    suffixIcon={<IoCalendarOutline className="text-color-500"/>}
                                    allowClear={false}
                                    format={gConfigs.dateFormat}
                                    defaultValue={value}
                                    placeholder={t('grade date')}
                                    onChange={(value) => {
                                        onChange(createValue(name, value))
                                    }}
                                />
                            )}
                        </Translate>
                    )
                },
            },
        ],
    },

    exam_create_new: {
        children: [
            {
                label: 'create online exam',
                name: 'exam_create_new',
                component: ({name, value, onChange}) => (
                    <Translate>
                        {(t) => (
                            <Radio.Group
                                name={name}
                                value={value}
                                onChange={onChange}
                                buttonStyle="solid"
                                optionType="button"
                                className="custom-radio-button"
                                options={baseFieldTypes.yesno.map(deepTranslate(t))}
                            />
                        )}
                    </Translate>
                ),
            },
        ],
    },

    exam_source: {
        children: [
            {
                label: 'select existing exam',
                name: 'from_course_class_exam_id',
                component: ({name, value, onChange, form, ...restForm}) => {
                    const _values = form?.values;
                    const {organization_id} = _values
                    return (
                        <Translate>
                            {(t) => (
                                <LookupField
                                    title={t('select existing exam')}
                                    createIfNotExists={false}
                                    defaultValue={form?.values?.from_course_class_exam_name}
                                    selectedOption={form?.values?.from_course_class_exam}
                                    placeholder="click to select"
                                    className="py-1.5"
                                    apiPath={`/courses/organization/${organization_id}/fetch-exams`}
                                    schema={courseClassExamSchema}
                                    name={name}
                                    OptionWrapper={({children, ...props}) =>
                                        <div
                                            className="flex items-center gap-2 border border-color-50 hover:shadow-md rounded-lg relative" {...props}>
                                            {children}
                                        </div>
                                    }
                                    renderOption={(o, i) => (
                                        <div key={i} className="flex flex-col flex-1 gap-0.5 py-1.5">
                                            <span className="font-semibold text-sm text-color-000 leading-snug">
                                                {o?.title}
                                            </span>
                                            {renderIf(o?.subject,
                                                <span className="text-xs text-color-400 italic leading-snug">
                                                    {o?.subject?.title}
                                                </span>
                                            )}
                                            {renderIf(o?.courseClass,
                                                <span className="text-xs text-color-400 italic leading-snug">
                                                    {o?.courseClass?.title}
                                                </span>
                                            )}
                                            {renderIf(o?.time_open,
                                                <span className="text-xs text-color-400 leading-snug">
                                                    {o?.time_open}
                                                </span>
                                            )}
                                        </div>
                                    )}
                                    handleChange={(e) => {
                                        form.setValues({
                                            ...form.values,
                                            from_course_class_exam: e.target,
                                            from_course_class_exam_name: e.target.value,
                                            from_course_class_exam_id: e.target.id
                                        });
                                    }}
                                />
                            )}
                        </Translate>
                    )
                },
            }
        ],
    },

    is_attendance: {
        children: [
            {
                label: 'attendance grade',
                name: 'is_attendance',
                component: ({name, value, onChange, form}) => (
                    <Translate>
                        {(t) => (
                            <Radio.Group
                                name={name}
                                value={value}
                                onChange={(e) => {
                                    form.setValues({
                                        ...form.values,
                                        is_attendance: !!e.target.value ? 1 : 0,
                                        exam_create_new: !!!e.target.value ? 1 : 0
                                    })
                                }}
                                buttonStyle="solid"
                                optionType="button"
                                className="w-full custom-radio-button"
                                options={baseFieldTypes.yesno.map(deepTranslate(t))}
                            />
                        )}
                    </Translate>
                ),
            },
        ],
    },
}


const GradeDateBadge = ({dateString, label, isStrikethrough = false, actions}) => {
    if (!dateString) return null;

    return (
        <div className={classNames(
            "flex flex-col items-start justify-between p-2 rounded-lg transition duration-200 ease-in-out",
            isStrikethrough ? 'bg-gray-100 text-gray-500 opacity-70 hover:opacity-100' : 'bg-white border border-blue-100 shadow-sm text-gray-700'
        )}>
            <div className="flex items-center space-x-2">
                <GoDotFill size={10} className={isStrikethrough ? 'text-gray-400' : 'text-blue-500'}/>
                <span className={classNames("text-xs whitespace-no-wrap italic", isStrikethrough && 'line-through')}>
                    {`${label}: `}
                </span>
                <span
                    className={classNames("text-sm font-semibold", isStrikethrough ? 'text-gray-500' : 'text-blue-600', isStrikethrough && 'line-through')}>
                    {formatDate(dateString, 'DD/MM/YYYY')}
                </span>
            </div>
            {actions && actions}
        </div>
    );
};

const GRADE_DETAIL_COLS = '24px 1fr 96px 96px 96px 30px'

const ScoreHistoryTrigger = ({logs, item, t}) => {
    if (!logs || !logs.length) return null
    return (
        <DrawDialog
            width={540}
            title={<div className="text-center font-bold text-gray-800 tracking-wider">{t('history')}</div>}
            closable={true}
            component={
                <span className="flex items-center justify-center w-full h-full text-color-400 hover:text-blue-600 cursor-pointer transition-colors">
                    <PiClockClockwiseLight size={14}/>
                </span>
            }>
            {(isToggle) => isToggle && <CourseClassGradeDetailHistory gradeDetail={item}/>}
        </DrawDialog>
    )
}

const renderGradeDetail = ({renderActions = NullAsDefault, isMobile = false} = {}) => (item, index) => {
    const {student, grade_date, grade_1_date, grade_2_date, logs} = item ?? {}
    const hasGradeDate = !!grade_date
    const hasGrade1Date = !!grade_1_date

    const scoreSlots = [
        {retake: 0, show: true},
        {retake: 1, show: hasGradeDate},
        {retake: 2, show: hasGrade1Date},
    ]

    return renderIf(
        student,
        <Translate key={index}>
            {(t) => isMobile ? (
                /* Mobile: stacked card, 44px tap targets */
                <div className="border-b border-color-50 px-3 py-2.5 hover:background-50 transition-colors">
                    <div className="flex items-start justify-between gap-2 mb-2">
                        <div className="min-w-0">
                            <p className="text-2xs text-color-300 leading-none truncate">
                                {getAliasName(student, 'patron_saint')}
                            </p>
                            <p className="font-semibold text-sm text-color-000 truncate leading-snug">
                                {student.fullname}
                            </p>
                        </div>
                        <div style={{width: 36, height: 36}} className="flex items-center justify-center flex-shrink-0">
                            <ScoreHistoryTrigger logs={logs} item={item} t={t}/>
                        </div>
                    </div>
                    <div className="flex gap-1.5">
                        {scoreSlots.map(({retake, show}) => show ? (
                            <div
                                key={retake}
                                style={{minHeight: 44}}
                                className="flex-1 flex rounded-lg border border-color-50 overflow-hidden background-50">
                                {renderActions(item, retake, true)}
                            </div>
                        ) : null)}
                    </div>
                </div>
            ) : (
                /* Desktop: grid table row */
                <div
                    className="flex items-stretch border-b border-color-50 hover:background-50 transition-colors px-3"
                    style={{display: 'grid', gridTemplateColumns: GRADE_DETAIL_COLS, minHeight: 42}}>

                    <span className="flex items-center text-xs text-color-400 tabular-nums">
                        {index + 1}
                    </span>

                    <div className="flex items-center min-w-0 pr-2 py-1.5">
                        <div className="min-w-0">
                            <p className="text-2xs text-color-300 leading-none truncate">
                                {getAliasName(student, 'patron_saint')}
                            </p>
                            <p className="font-semibold text-sm text-color-000 truncate leading-snug">
                                {student.fullname}
                            </p>
                        </div>
                    </div>

                    {scoreSlots.map(({retake, show}) => (
                        <div key={retake} className="flex items-stretch border-l border-color-50">
                            {show ? renderActions(item, retake, true) : null}
                        </div>
                    ))}

                    <div className="flex items-center justify-center border-l border-color-50">
                        <ScoreHistoryTrigger logs={logs} item={item} t={t}/>
                    </div>
                </div>
            )}
        </Translate>
    )
}


export const CourseClassGradeCreateForm = ({
                                               course_class,
                                               initialValues,
                                               onSubmit = NullAsDefault,
                                               isSubmitting = false,
                                           }) => {
    const t = useTranslate()

    const course_id = getId(course_class?.course)
    const organization_id = getId(course_class?.owner)

    const _initialValues = useMemo(
        () => ({
            organization_id,
            course_id,
            course_class,
            score_weight: 1,
            exam_create_new: 0,
            is_attendance: 0,
            score_type: grade_score_types.number.value,
            title: _.capitalize(dayjs().format('dddd, DD/MM/YYYY')),
            score_type_options: [grade_score_types.number, grade_score_types.text],
            subject_id: initialValues?.subject_id || initialValues?.subject?.id,
            ...(initialValues ?? {}),
        }),
        [course_id, initialValues]
    )

    const validate = (values) => {
        let errors = {}

        const {title} = values ?? {}

        if (_.isEmpty(title ?? '')) {
            errors.title = t('required field')
        }

        return errors
    }

    return (
        <Formik
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={_initialValues}
            onSubmit={(values) => {
                const {
                    subject, course_id, grade_date, score_type_options, exam_create_new, course_class,
                    from_course_class_exam, from_course_class_exam_name, from_course_class_exam_id, ...rest
                } =
                values ?? {}
                const score_options = Array.from(rest?.score_options ?? [])
                onSubmit(
                    _.omitBy(
                        {
                            ...rest,
                            exam_create_new: !!exam_create_new ? 1 : 0,
                            from_course_class_exam_id: !!exam_create_new ? from_course_class_exam_id : undefined,
                            subject_id: values?.subject ? getId(subject) : (values?.subject_id || null),
                            grade_date: getDateString(grade_date),
                            score_options: score_options.length > 0 ? score_options : undefined,
                        },
                        _.isUndefined
                    )
                )
            }}>
            <ActionModalWrapper
                className="gap-4"
                action={
                    <div className="flex items-center justify-end p-2 background">
                        <ResetButton disabled={isSubmitting}/>
                        <SubmitButton
                            label="create"
                            dirtyRequired={false}
                            loading={isSubmitting}
                        />
                    </div>
                }>
                <CourseClassInformation
                    item={course_class}
                    showDescription={false}
                />
                <div className="flex flex-col gap-1">
                    <FieldsFactory formSchema={[formSchema.title]}/>
                    <span className="text-xs text-color-400 italic">
                        {`* ${t('create title grades description')}`}
                    </span>
                </div>
                <Pure>
                    <FieldsFactory
                        formSchema={[
                            formSchema.course_subject,
                            formSchema.score_type_weight_date,
                        ]}
                    />
                </Pure>
                <FormikConsumer>
                    {({values}) => {
                        const has_options =
                            values?.score_type === grade_score_types.text.value
                        return renderIf(
                            has_options,
                            <Pure>
                                <FieldsFactory formSchema={[formSchema.score_options]}/>
                                <span className="text-sm text-color-400 italic whitespace-nowrap">{`* ${t('ex: A+, A, B+, C')}`}</span>
                            </Pure>
                        )
                    }}
                </FormikConsumer>

                <div className="flex flex-col gap-3 p-3 rounded-xl border border-color-100 background-50">
                    <div>
                        <span className="text-xs font-semibold text-color-300 uppercase tracking-wide">
                            {t('online exam')}
                        </span>
                        <p className="text-xs text-color-400 italic mt-1 mb-0">
                            {t('online exam form description')}
                        </p>
                    </div>
                    <Pure>
                        <FieldsFactory formSchema={[formSchema.exam_create_new]}/>
                    </Pure>
                    <FormikConsumer>
                        {({values}) => values.exam_create_new ? (
                            <Pure>
                                <FieldsFactory formSchema={[formSchema.exam_source]}/>
                            </Pure>
                        ) : null}
                    </FormikConsumer>
                </div>

                <div className="flex flex-col gap-2 p-3 rounded-xl border border-amber-100 bg-amber-50">
                    <div className="flex items-center gap-1.5">
                        <span className="text-xs font-semibold text-amber-600 uppercase tracking-wide">
                            {t('attendance grade')}
                        </span>
                    </div>
                    <span className="text-xs text-amber-700 italic opacity-80">
                        {t('attendance grade form description')}
                    </span>
                    <Pure>
                        <FieldsFactory formSchema={[formSchema.is_attendance]}/>
                    </Pure>
                </div>

            </ActionModalWrapper>
        </Formik>
    )
}

export const CourseClassGradeUpdateForm = ({
                                               course_class,
                                               initialValues,
                                               onSubmit = NullAsDefault,
                                               isSubmitting = false,
                                           }) => {
    const t = useTranslate()

    const course_id = getId(course_class?.course)

    const _initialValues = useMemo(() => {
        const {score_options, grade_date, ...rest} = initialValues ?? {}
        return {
            ...rest,
            course_id,
            course_class,
            exam_create_new: !!rest?.exam_create_new ? 1 : 0,
            score_options: String(score_options ?? '').split(','),
            grade_date: parseDayjs(grade_date),
            score_type_options: [grade_score_types.number, grade_score_types.text],
            subject_id: initialValues?.subject_id || initialValues?.subject?.id,
            is_edit: true
        }
    }, [course_id, initialValues])

    const validate = (values) => {
        let errors = {}

        const {title} = values ?? {}

        if (_.isEmpty(title ?? '')) {
            errors.title = t('required field')
        }

        return errors
    }

    return (
        <Formik
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={_initialValues}
            onSubmit={(values) => {
                const changes = shallowDiff(values, initialValues)
                const {subject, course_id, score_type_options, grade_date, exam_create_new, ...rest} =
                changes ?? {}
                const score_options = Array.from(rest?.score_options ?? [])
                onSubmit(
                    _.omitBy(
                        {
                            ...rest,
                            grade_date: getDateString(grade_date),
                            subject_id: values?.subject ? getId(values.subject) : (values?.subject_id || null),
                            score_options: score_options.length > 0 ? score_options : null,
                        },
                        _.isUndefined
                    )
                )
            }}>
            <ActionModalWrapper
                className="gap-4"
                action={
                    <div className="flex items-center justify-end p-2 background">
                        <ResetButton disabled={isSubmitting}/>
                        <SubmitButton
                            label="save"
                            dirtyRequired={false}
                            loading={isSubmitting}
                        />
                    </div>
                }>
                <CourseClassInformation
                    item={course_class}
                    showDescription={false}
                    className="mb-1"
                />
                <Pure>
                    <FieldsFactory
                        formSchema={[
                            formSchema.title,
                            formSchema.course_subject,
                            formSchema.score_type_weight_date,
                        ]}
                    />
                </Pure>
                <FormikConsumer>
                    {({values}) => {
                        const has_options =
                            values?.score_type === grade_score_types.text.value
                        return renderIf(
                            has_options,
                            <Pure>
                                <FieldsFactory formSchema={[formSchema.score_options]}/>
                            </Pure>
                        )
                    }}
                </FormikConsumer>

                <div className="flex flex-col gap-2 p-3 rounded-xl border border-amber-100 bg-amber-50">
                    <div className="flex items-center gap-1.5">
                        <span className="text-xs font-semibold text-amber-600 uppercase tracking-wide">
                            {t('attendance grade')}
                        </span>
                    </div>
                    <span className="text-xs text-amber-700 italic opacity-80">
                        {t('attendance grade form description')}
                    </span>
                    <Pure>
                        <FieldsFactory formSchema={[formSchema.is_attendance]}/>
                    </Pure>
                </div>
            </ActionModalWrapper>
        </Formik>
    )
}

const ScoreEditorWrapper = ({style, className, children}) => (
    <div
        style={style}
        className={classNames(
            'flex flex-col gap-2 items-center w-full',
            className
        )}>
        {children}
    </div>
)

const GradeScoreEditor = ({
                              item,
                              grade,
                              retake = 0,
                              onSubmit = NullAsDefault,
                              isSubmitting = false,
                          }) => {
    const t = useTranslate()

    const initialValues = useMemo(() => {
        const {score_options, score_type} = grade ?? {}
        switch (retake) {
            case 1:
                return {
                    score_options,
                    score_text: item?.score_1_text,
                    score_number: item?.score_1_number,
                    score_type: score_type ?? grade_score_types.number.value,
                    grade_date: parseDayjs(item?.grade_1_date || grade?.grade_date),
                }
            case 2:
                return {
                    score_options,
                    score_text: item?.score_2_text,
                    score_number: item?.score_2_number,
                    score_type: score_type ?? grade_score_types.number.value,
                    grade_date: parseDayjs(item?.grade_2_date || grade?.grade_date),
                }
            default:
                return {
                    score_options,
                    score_text: item?.score_text,
                    score_number: item?.score_number,
                    score_type: score_type ?? grade_score_types.number.value,
                    grade_date: parseDayjs(item?.grade_date || grade?.grade_date),
                }
        }
    }, [item, grade, retake])

    const validate = (values) => {
        let errors = {}
        const {score_type, score_text, score_number} = values ?? {}
        if (
            score_type === grade_score_types.text.value &&
            _.isEmpty(String(score_text ?? ''))
        ) {
            errors.score_text = t('required field')
        }
        if (
            score_type === grade_score_types.number.value &&
            !_.isNumber(score_number)
        ) {
            errors.score_number = t('required field')
        }
        return errors
    }

    const {student} = item ?? {}
    const {prefix_title, patron_saint_name, fullname} = student ?? {}

    return (
        <Formik
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={initialValues}
            onSubmit={(values) => {
                const {score_type, score_text, score_number, grade_date} =
                values ?? {}
                let score
                switch (score_type) {
                    case grade_score_types.text.value:
                        score = score_text
                        break
                    case grade_score_types.number.value:
                        score = score_number
                        break
                    default:
                        score = score_number
                        break
                }
                onSubmit(
                    _.omitBy(
                        {
                            grade_date: getDateString(grade_date),
                            retake,
                            score,
                        },
                        _.isUndefined
                    )
                )
            }}>
            <div className="flex flex-col gap-4 items-center">
                <div className="p-4 flex items-center gap-4">
                    <Avatar
                        size={70}
                        src={student?.avatar || student?.user?.avata}
                        icon={<BsPersonFill size={30} className="text-color-500"/>}
                        className="flex flex-center background-200 object-cover shadow-lg border-2 border-indigo-500"
                    />
                    <div className="flex flex-col flex-1">
                        <h2 className="text-xl font-bold text-color-000 tracking-wide">
                            {`${prefix_title || patron_saint_name || ''} ${fullname}`}
                        </h2>
                        <span className="font-medium text-sm text-indigo-500 italic">
                            {getTitle(grade.subject)}
                        </span>
                        <span className="text-xs text-color-300 tracking-wider">
                            {grade.title}
                        </span>
                    </div>
                </div>

                <FormikConsumer>
                    {({values, handleChange}) => {
                        const {score_type, score_text, score_number, score_options} =
                            values
                        switch (score_type) {
                            case grade_score_types.text.value:
                                const options = String(score_options ?? '').split(',')
                                return renderIf(
                                    options.length,
                                    <Pure input={[options, score_text]}>
                                        <ScoreEditorWrapper>
                                            <div className="w-full mt-6">
                                                <GradeLetterInput
                                                    defaultValue={score_text}
                                                    onChange={(value) => {
                                                        handleChange(createValue('score_text', value))
                                                    }}
                                                />

                                            </div>

                                        </ScoreEditorWrapper>
                                    </Pure>
                                )
                            case grade_score_types.number.value:
                                const number = _.isNumber(score_number)
                                    ? score_number
                                    : undefined
                                return (
                                    <Pure input={[number]}>
                                        <ScoreEditorWrapper>

                                            <div className="w-full mt-6">
                                                <GradeNumberInput
                                                    defaultValue={Number(number ?? 0)}
                                                    onChange={(value) => {
                                                        handleChange(createValue('score_number', value))
                                                    }}
                                                />

                                            </div>
                                        </ScoreEditorWrapper>
                                    </Pure>
                                )
                            default:
                                break
                        }
                        return null
                    }}
                </FormikConsumer>

                <FormikConsumer>
                    {({values, handleChange}) => {
                        const {grade_date} = values
                        return (
                            <DatePicker
                                className="w-full"
                                placeholder={t('Select date')}
                                allowClear={false}
                                format="DD/MM/YYYY"
                                suffixIcon={<IoCalendarOutline className="text-color-500"/>}
                                defaultValue={grade_date ?? undefined}
                                onChange={(value) => {
                                    handleChange(createValue('grade_date', value))
                                }}
                            />
                        )
                    }}
                </FormikConsumer>

                <div className="mt-3 flex w-full">
                    <SubmitButton
                        label="save"
                        className="button-rounded-lg py-1 w-full"
                        dirtyRequired={false}
                        loading={isSubmitting}
                    />
                </div>
            </div>
        </Formik>
    )
}

const GradeInformation = ({item}) => {
    const t = useTranslate()
    const {title, subject, course_class, score_type} = item ?? {}
    return (
        <React.Fragment>
            <div className="flex flex-col gap-1">
                <HeaderWithIconLine
                    icon={<BsInfoCircleFill size={14} className="text-color-500"/>}
                    title="class information"
                    className="text-sm text-color-300"
                />
                <div className="flex flex-col gap-1 ml-3">
                    <ItemInformation
                        showIcon={true}
                        className="text-xs italic"
                        label="classes"
                        value={getTitle(course_class)}
                    />
                    <ItemInformation
                        showIcon={true}
                        className="text-xs italic"
                        label="title of grade"
                        value={title}
                    />
                    <ItemInformation
                        showIcon={true}
                        className="text-xs italic"
                        label="number of student"
                        value={_.get(course_class, 'number_of_students')}
                    />
                    <ItemInformation
                        showIcon={true}
                        className="text-xs italic"
                        label="subjects"
                        value={_.get(subject, 'title')}
                    />
                    <ItemInformation
                        showIcon={true}
                        className="text-xs italic"
                        label="score type"
                        value={t(score_type)}
                    />
                </div>
            </div>
            <div className="flex flex-col gap-1 italic py-2">
                <div className="flex items-center gap-2">
                    <BiSolidMagicWand size={14} className="text-blue-300"/>
                    <span className="font-medium text-sm text-blue-600">
                        {`${t('the guide on how to grade')} : `}
                    </span>
                </div>
                <span className="ml-3 space-x-2 leading-tight">
                    <BiMessageSquareAdd
                        size={13}
                        className="text-green-300"
                    />
                    <span className="text-sm text-color-400">
                    {`: ${t('step 1 description')}`}
                  </span>
                </span>
                <span className="ml-3 space-x-2 leading-tight">
                    <BiMessageSquareEdit
                        size={13}
                        className="text-blue-400"
                    />
                    <span className="text-sm text-color-400">
                        {`: ${t('step 2 description')}`}
                    </span>
                </span>
                <span className="ml-3 space-x-2 leading-tight">
                    <BiTrash
                        size={13}
                        className="text-red-300"
                    />
                    <span className="text-sm text-color-400">
                        {`: ${t('step 3 description')}`}
                    </span>
                </span>
            </div>
        </React.Fragment>
    )
}

// --- Grading sub-tab: list attempts + inline evaluate ---
const ExamAttemptsGradePanel = ({grade}) => {
    const t = useTranslate()
    const exam = grade && grade.course_class_exam
    const exam_id = exam && exam.id
    const [statusFilter, setStatusFilter] = useState('')
    const [selected, setSelected] = useState(null)
    const [listRefreshToken, setListRefreshToken] = useState(0)

    const {handleAsyncAction: doEvaluate} = useAsyncAction({
        apiInfo: course_class_exam_evaluateExamAttempt_Api,
        onError: notifyOnError(t),
        onSuccess: () => {
            setSelected(null)
            setListRefreshToken(function(prev) { return prev + 1 })
        },
    })

    const {handleAsyncAction: doRemove} = useAsyncAction({
        apiInfo: course_class_exam_removeExamAttempt_Api,
        onError: notifyOnError(t),
        onSuccess: () => {
            setListRefreshToken(function(prev) { return prev + 1 })
        },
    })

    const refreshKey = [exam_id, statusFilter, listRefreshToken].join('/')

    const statusOpts = [
        {value: '', label: t('All')},
        {value: '1', label: t('Pending')},
        {value: '9', label: t('Graded')},
    ]

    const renderAttemptRow = useCallback((item, index) => {
        const student = item && item.student
        const statusLabel = item.status === 9
            ? t('Graded') : item.status === 1
                ? t('Pending') : t('In progress')
        const statusColor = item.status === 9
            ? 'text-green-600 bg-green-50 border-green-200'
            : item.status === 1
                ? 'text-amber-600 bg-amber-50 border-amber-200'
                : 'text-gray-400 bg-gray-50 border-gray-200'

        const handleDelete = (e) => {
            e.stopPropagation()
            showDeleteConfirmDialog({
                translate: t,
                title: 'delete exam attempt',
                message: 'delete exam attempt confirm',
                onOk: () => doRemove({}, {id: item.id}),
            })
        }

        return (
            <div key={index}
                className="flex items-center gap-3 px-3 py-2.5 border-b border-color-50 last:border-0 hover:background-50 cursor-pointer group"
                onClick={() => setSelected(item)}>
                <div className="w-6 h-6 rounded-full bg-indigo-100 flex items-center justify-center flex-shrink-0">
                    <BsPersonFill size={12} className="text-indigo-500"/>
                </div>
                <div className="flex-1 min-w-0">
                    <p className="text-sm font-semibold text-color-100 truncate">
                        {(student && student.fullname) || t('Unknown')}
                    </p>
                    <p className="text-xs text-color-400">{item.created}</p>
                </div>
                <div className="flex items-center gap-2 flex-shrink-0">
                    {item.status === 9 && (
                        <span className="text-sm font-bold text-color-100">
                            {item.score}<span className="text-xs text-color-400">/{item.max_score}</span>
                        </span>
                    )}
                    <span className={classNames('text-2xs font-semibold px-2 py-0.5 rounded-full border', statusColor)}>
                        {statusLabel}
                    </span>
                    <button
                        type="button"
                        title={t('delete exam attempt')}
                        onClick={handleDelete}
                        style={{width: 30, height: 30}}
                        className="flex items-center justify-center rounded-lg text-color-400 hover:text-red-500 hover:bg-red-50 transition-colors opacity-0 group-hover:opacity-100">
                        <BiTrash size={14}/>
                    </button>
                </div>
            </div>
        )
    }, [t, doRemove])

    if (!exam_id) return null

    return (
        <div className="flex flex-col">
            {/* Status filter */}
            <div className="flex gap-1 px-3 py-2 border-b border-color-50">
                {statusOpts.map(opt => (
                    <button key={opt.value}
                        type="button"
                        onClick={() => setStatusFilter(opt.value)}
                        className={classNames(
                            'px-3 py-1 rounded-lg text-xs font-semibold transition-colors',
                            statusFilter === opt.value
                                ? 'bg-indigo-600 text-white'
                                : 'text-color-300 hover:bg-color-50 hover:text-color-100'
                        )}>
                        {opt.label}
                    </button>
                ))}
            </div>

            {/* Attempt list */}
            <div className="border border-color-50 rounded-xl overflow-hidden mx-3 mt-3">
                <EntityList
                    key={refreshKey}
                    apiInfo={course_class_exam_fetchAttemptsFiltered_Api}
                    values={{status: statusFilter || undefined}}
                    refreshKey={refreshKey}
                    RenderEntity={React.Fragment}
                    query={bindQueryParam({id: exam_id})}
                    renderItem={renderAttemptRow}
                    renderEmpty={() => (
                        <div className="p-6 text-center text-sm text-color-400">
                            {t('No attempts found')}
                        </div>
                    )}
                />
            </div>

            {/* Evaluate modal */}
            {selected && (
                <Modal
                    open={true}
                    footer={null}
                    width={720}
                    onCancel={() => setSelected(null)}
                    destroyOnHidden={true}
                    className="custom-modal"
                    title={
                        <div className="font-bold text-color-000">
                            {t('Grade exam attempt')} — {selected.student && selected.student.fullname}
                        </div>
                    }>
                    <CourseClassExamAttemptEvaluateForm
                        attempt={selected}
                        course_class_exam={selected.course_class_exam || exam}
                        onSubmit={(values) => {
                            doEvaluate(values, {id: selected.id})
                        }}
                    />
                </Modal>
            )}
        </div>
    )
}

export const CourseClassGradesForm = ({item, grade}) => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)

    const [current, setCurrent] = useState()
    const [activeTab, setActiveTab] = useState('grades')

    const [keyword, setKeyword] = useState()
    const [sub_class_name, setSubClassName] = useState()

    const hasExam = !!(grade && grade.course_class_exam)

    const onCancel = () => {
        setCurrent(null)
    }

    const grade_id = getId(grade)

    const apiInfo = course_class_getGradeDetails_Api

    const refreshKey = useMemo(
        () =>
            [
                apiInfo.path.replace(':id', grade_id),
                JSON.stringify(keyword),
                sub_class_name
            ].join(
                '/'
            ),
        [keyword, sub_class_name, grade_id]
    )

    const {handleAsyncAction: setGradeStatus} = useAsyncAction({
        onError: notifyOnError(t),
        apiInfo: course_class_setGradeScore_Api,
        // onSuccess: (result, data) => {
        //   successNotify(NotificationActionTypes.INFORMATION, t)
        // },
    })

    const onSearch = _.debounce((keyword) => {
        setKeyword(keyword)
    }, 500)

    const renderActions = useCallback(
        (item, retake = 0, compact = false) => {
            const {
                grade_date,
                score_text,
                score_number,
                grade_1_date,
                score_1_text,
                score_1_number,
                grade_2_date,
                score_2_text,
                score_2_number,
                score_type,
            } = item ?? {}
            const lastReTake = !!grade_2_date ? 2 : !!grade_1_date ? 1 : 0
            let score = score_type === 'text' ? score_text : score_number
            let gdate = grade_date
            switch (retake) {
                case 1:
                    score = score_type === 'text' ? score_1_text : score_1_number
                    gdate = grade_1_date
                    break
                case 2:
                    score = score_type === 'text' ? score_2_text : score_2_number
                    gdate = grade_2_date
                    break
                default:
                    break
            }

            const handleDelete = () => {
                showDeleteConfirmDialog({
                    translate: t,
                    title: 'delete scores',
                    message: 'are you sure you want to delete this score',
                    onOk: () => {
                        setGradeStatus(
                            {delete: 1, retake},
                            {
                                detail_id: item?.id,
                                grade_id: item?.grade?.id,
                            }
                        )
                    },
                })
            }

            if (compact) {
                if (gdate) {
                    return (
                        <div className={classNames('flex items-stretch h-full w-full', lastReTake !== retake && 'opacity-40')}>
                            <span className={classNames(
                                'flex items-center justify-center flex-1 text-sm font-bold tabular-nums',
                                lastReTake !== retake ? 'text-color-300 line-through' : 'text-color-000'
                            )}>
                                {score ?? '—'}
                            </span>
                            <button
                                type="button"
                                onClick={() => setCurrent({...item, retake})}
                                className="flex items-center justify-center px-1 text-blue-500 hover:text-blue-700 active:background-100 transition-colors">
                                <BiMessageSquareEdit size={17}/>
                            </button>
                            <button
                                type="button"
                                onClick={handleDelete}
                                className="flex items-center justify-center px-1 active:background-100 transition-colors">
                                <BiTrash size={17} className="text-primary-300 hover:text-primary-600"/>
                            </button>
                        </div>
                    )
                }
                return (
                    <button
                        type="button"
                        onClick={() => setCurrent({...item, retake})}
                        className="flex items-center justify-center w-full h-full text-green-400 hover:text-green-600 active:background-50 transition-colors">
                        <BiMessageSquareAdd size={17}/>
                    </button>
                )
            }

            const modes = {
                insert: {
                    tooltip: t('add'),
                    icon: (
                        <BiMessageSquareAdd size={20}/>
                    ),
                },
                update: {
                    tooltip: t('edit'),
                    icon: (
                        <BiMessageSquareEdit size={20}/>
                    ),
                },
            }
            const {icon} = gdate ? modes.update : modes.insert;

            if (gdate) {
                return (
                    <div
                        style={{paddingLeft: '1rem'}}
                        className={classNames('w-full flex items-center gap-x-4 leading-tight', lastReTake !== retake && 'opacity-40')}>
                    <span
                        style={{minWidth: 100}}
                        className={classNames('flex-1 text-xs text-color-400 italic', lastReTake !== retake && 'text-line-through')}>
                        {`${t('score times')} ${retake + 1} : `}
                        <span
                            className={classNames('font-bold', lastReTake !== retake ? 'text-color-300' : 'text-color-000')}>
                            {score}
                        </span>
                    </span>
                        <div
                            onClick={() => {
                                setCurrent({...item, retake})
                            }}
                            className="flex flex-center text-blue-500 hover:text-blue-700 cursor-pointer">
                            {icon}
                        </div>
                        <div
                            className="flex flex-center text-primary-400 hover:text-primary-600 cursor-pointer"
                            onClick={handleDelete}>
                            <BiTrash size={20} className="text-primary-300"/>
                        </div>
                    </div>
                )
            }
            return (
                <div
                    style={{marginLeft: 6}}
                    onClick={() => {
                        setCurrent({...item, retake})
                    }}
                    className="flex flex-center text-green-300 hover:text-primary cursor-pointer">
                    {icon}
                    <span className="ml-1 text-sm italic">
                        {t('add new score')}
                    </span>
                </div>
            )
        },
        [grade_id]
    )

    return (
        <div className="flex flex-col space-y-3">
            <div className="px-3 pt-3">
                <GradeInformation item={grade}/>
            </div>

            {/* Sub-tab bar — chỉ hiện khi có exam */}
            {hasExam && (
                <div className="flex gap-1 px-3 border-b border-color-50 pb-0">
                    {[
                        {key: 'grades', label: t('list of students')},
                        {key: 'exam', label: t('Grade exams')},
                    ].map(tab => (
                        <button key={tab.key}
                            type="button"
                            onClick={() => setActiveTab(tab.key)}
                            className={classNames(
                                'px-3 py-2 text-xs font-semibold rounded-t-lg transition-colors border-b-2 -mb-px',
                                activeTab === tab.key
                                    ? 'border-indigo-600 text-indigo-600 bg-indigo-50/40'
                                    : 'border-transparent text-color-400 hover:text-color-100'
                            )}>
                            {tab.label}
                        </button>
                    ))}
                </div>
            )}

            {/* Tab: Danh sách điểm */}
            {activeTab === 'grades' && (
                <div className="flex flex-col space-y-3 px-3 pb-3">
                    <div className="flex flex-col space-y-3">
                        <Input.Search
                            name="keyword"
                            autoComplete="off"
                            allowClear={true}
                            onSearch={onSearch}
                            placeholder={t('type to search')}
                            className="input-search-with-icon"
                            onChange={(event) => {
                                onSearch(event.target && event.target.value)
                            }}
                        />
                        <SubClassTags
                            items={_.get(item, 'sub_class_names', [])}
                            selected={sub_class_name}
                            setSelected={setSubClassName}
                        />
                    </div>
                    <div className="flex flex-col gap-0">
                        {!isSm && (
                            <div
                                className="items-center border-b border-color-100 px-3 py-1.5 background-50 rounded-t-lg"
                                style={{display: 'grid', gridTemplateColumns: GRADE_DETAIL_COLS}}>
                                <span className="text-2xs font-semibold text-color-400">#</span>
                                <span className="text-2xs font-semibold text-color-400">{t('student')}</span>
                                <span className="text-2xs font-semibold text-color-400 text-center">{t('score times')} 1</span>
                                <span className="text-2xs font-semibold text-color-400 text-center">{t('score times')} 2</span>
                                <span className="text-2xs font-semibold text-color-400 text-center">{t('score times')} 3</span>
                                <span/>
                            </div>
                        )}
                        <EntityList
                            apiInfo={apiInfo}
                            values={{keyword, sub_class_name}}
                            refreshKey={refreshKey}
                            RenderEntity={React.Fragment}
                            query={bindQueryParam({id: grade_id})}
                            renderItem={renderGradeDetail({renderActions, isMobile: isSm})}
                        />
                    </div>
                    {renderIf(
                        current,
                        <Modal
                            footer={null}
                            open={current}
                            onCancel={onCancel}
                            destroyOnHidden={true}
                            className="custom-modal"
                            title={
                                <div className="text-center text-color-000 font-bold uppercase">
                                    {t('grade of students')}
                                </div>
                            }>
                            <GradeScoreEditor
                                grade={grade}
                                item={current}
                                retake={current && current.retake}
                                onSubmit={(values) => {
                                    setGradeStatus(values, {
                                        grade_id,
                                        detail_id: getId(current),
                                    })
                                    onCancel()
                                }}
                            />
                        </Modal>
                    )}
                </div>
            )}

            {/* Tab: Chấm bài thi */}
            {activeTab === 'exam' && hasExam && (
                <ExamAttemptsGradePanel grade={grade}/>
            )}
        </div>
    )
}


const renderGradeStats = ({renderActions} = {}) => (item, index) => {
    const {student, avg_score, passed_score_status} = item ?? {}
    const {prefix_title, fullname} = student ?? {}

    let label_status
    let color_status
    switch (passed_score_status) {
        case 1:
            label_status = 'passed'
            color_status = 'text-green-600'
            break
        case 0:
            label_status = 'failed'
            color_status = 'text-red-600'
            break
        default:
            label_status = 'not assessed yet'
            color_status = 'text-color-300'
            break
    }

    return (
        <Translate>
            {(t) => (
                <div
                    key={index}
                    className="px-2 py-1 flex items-center border border-color-50 hover:shadow-items-md rounded-md relative">
                    <div className="w-full flex items-center gap-3">
                        <div className="flex flex-col flex-1 truncate">
                            <div className="font-bold text-sm text-color-000 italic tracking-wide truncate">
                                <span className="font-medium text-color-200">
                                    {`${index + 1}. `}
                                </span>
                                {renderIf(
                                    prefix_title,
                                    <span className="mr-1 font-medium text-color-200">
                                        {`${prefix_title} `}
                                    </span>
                                )}
                                {fullname}
                            </div>
                            {renderIf(
                                avg_score,
                                <span className="ml-1 space-x-1 leading-tight">
                                            <span
                                                className="text-xs text-color-400">{`${t('score of student')} : `}</span>
                                            <span className="font-bold text-xs text-color-100">
                                              {avg_score}
                                            </span>
                                            <span className="text-xs text-color-500 lowercase">{t('score')}</span>
                                        </span>
                            )}
                        </div>
                        <span
                            className={classNames("font-bold text-xs tracking-wide uppercase opacity-80", color_status)}>
                            {t(label_status)}
                        </span>
                    </div>
                    <div className="p-1 absolute top-0 right-0">
                        {renderActions}
                    </div>
                </div>
            )}
        </Translate>
    )
}

export const CourseClassStudentGradeStats = ({courseClass}) => {
    const t = useTranslate()
    const [current, setCurrent] = useState()
    const [subject, setSubject] = useState(null)

    const onCancel = () => {
        setCurrent(null)
    }

    const apiInfo = course_class_student_getGradeResult_Api

    const refreshKey = useMemo(
        () =>
            [
                apiInfo.path
                    .replace(':course_class_id', courseClass?.id)
                    .replace(':subject_id', subject?.id)
            ].join('/'),
        [courseClass, subject]
    )

    const {passed_score} = subject ?? {}

    return (
        <div className="flex flex-col gap-3 p-3">
            <div className="flex flex-col gap-2 mb-3">
                <ListHeaderLineAndDes
                    title="choose subject"
                    description="choose subject score statistics"
                />
                <SubjectSelector
                    value={subject}
                    onChange={(e, ...rest) => {
                        const subject = e.target.value;
                        setSubject(subject)
                    }}
                    course_id={courseClass?.course?.id}
                />
                {renderIf(
                    passed_score > 0,
                    <span className="ml-1 mt-1 font-bold text-sm text-green-600 italic">
                        <span className="font-medium text-color-200 italic">
                            {`* ${t('passed score')} : `}
                        </span>
                        {passed_score}
                        <span className="ml-1 font-medium lowercase">
                          {t('score')}
                        </span>
                    </span>
                )}
            </div>
            <div className="flex flex-col gap-3">
                <ListHeaderWithLine
                    title="list of students"
                    className="text-sm"
                />
                <EntityList
                    apiInfo={apiInfo}
                    key={refreshKey}
                    query={bindQueryParams([
                        {course_class_id: courseClass?.id},
                        {subject_id: subject?.id},
                    ])}
                    renderItem={renderGradeStats({})}
                    RenderEntity={React.Fragment}
                />
            </div>
        </div>
    )
}